import { useState } from "react";
import CardAdd from "components/billing/CardAdd";
import { FilingsTimeline } from "components/FilingsTimeline/FilingsTimeline";
import { HeaderActions } from "components/AppLayout/HeaderActions";
import { EntityScopeSelector } from "components/home/EntityScopeSelector";
import { FreeFilingBanner } from "components/home/FreeFilingBanner";
import { TasksActions } from "components/home/TaxComponents/TasksOverview/TasksOverview";
import FreeSubscriptionModal from "components/tasks/task7004/FreeSubscriptionModal";
import { motion } from "framer-motion";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { entitiesSortedByCountry } from "utils/entitiesSortedByCountry";
import { useDispatch, useSelector } from "react-redux";
import {
  closeCardAddModal,
  closeFreeSubscription,
} from "store/slices/subscriptionModal";
import { RootState } from "store/store";

export const GroupHome = ({ groupId }: { groupId: string }) => {
  const { entities } = useCurrentGroupContext();

  const [selectedEntityIds, setSelectedEntityIds] = useState<string[]>([]);

  // US entities only — the timeline plots US filings.
  const { usEntities } = entitiesSortedByCountry(entities);
  const usEntityIds = usEntities.map((entity) => entity.uuid);

  // Nothing selected means every US entity, as on the customer's own home.
  const scopedEntityIds =
    selectedEntityIds.length > 0 ? selectedEntityIds : usEntityIds;
  const dispatch = useDispatch();
  const { isOpenFreeSubscription, isOpenCardAddModal } = useSelector(
    (state: RootState) => state.subscriptionModal
  );

  return (
    <div className="t-mx-6">
      {/* The selector belongs beside the page title, but its state stays
          here — HeaderActions portals without moving the subtree. */}
      {usEntities.length > 1 && (
        <HeaderActions>
          <EntityScopeSelector
            selectedEntityIds={selectedEntityIds}
            onChange={setSelectedEntityIds}
          />
        </HeaderActions>
      )}

      <motion.div layout className="t-pb-8">
        <FreeFilingBanner />
        <div className="t-flex t-flex-col t-gap-5">
          {usEntityIds.length > 0 && (
            <div className="sm:t-hidden">
              <FilingsTimeline entityIds={scopedEntityIds} />
            </div>
          )}

          <TasksActions
            entityIds={scopedEntityIds}
            isScopeReady={usEntityIds.length > 0}
          />
        </div>
      </motion.div>
      <FreeSubscriptionModal
        openSubscription={isOpenFreeSubscription}
        closeSubscription={() => dispatch(closeFreeSubscription())}
      />
      {isOpenCardAddModal && (
        <CardAdd
          openAddCard={isOpenCardAddModal}
          closeAddCard={() => dispatch(closeCardAddModal())}
        />
      )}
    </div>
  );
};
